import { enabledCloudFullscreen } from 'reactApp/appHelpers/featuresHelpers/features/fullscreen';
import { loadPaidInfoRequest } from 'reactApp/modules/paidInfo/paidInfo.module';
import { handlePaidInfoSuccess } from 'reactApp/modules/paidInfo/paidInfo.saga';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { store } from 'reactApp/store';
import { renderFullScreenMonetization } from 'reactApp/ui/FullScreenMonetization/FullScreenMonetization';
import { call } from 'redux-saga/effects';
import { put, select } from 'typed-redux-saga';

import { PromoSelectors } from '../promo.selectors';

const FULLSCREEN_CLOUD_ID = 'fullscreenCloud';

export function* initFullscreen() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);

    if (!enabledCloudFullscreen || !isHome || storeHelper.getValue(FULLSCREEN_CLOUD_ID)) {
        return;
    }

    yield put(loadPaidInfoRequest());
    yield handlePaidInfoSuccess();

    const isUserWithoutPayment = yield select(PaidInfoSelectors.isUserWithoutPayment);

    if (!isUserWithoutPayment) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.fullScreenCloud,
            promoId: FULLSCREEN_CLOUD_ID,
            onShow: () => {
                store.dispatch(promoShown(EPromoType.fullScreenCloud));
                storeHelper.markAsShown(FULLSCREEN_CLOUD_ID);
            },
            onClose: () => {
                store.dispatch(removePromo(EPromoType.fullScreenCloud));
                storeHelper.markAsShown(FULLSCREEN_CLOUD_ID);
            },
        })
    );
}

export function* showFullscreenDialog() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.fullScreenCloud));

    if (promo && enabledCloudFullscreen) {
        const { onShow, onClose } = promo;

        yield call(renderFullScreenMonetization, { onShow, onClose });
    }
}
